import { t } from '@lingui/macro';

// Card- and row-level readings of an integration, shared by the home layouts.

export const audienceLabel = (integration) =>
  integration.audience?.length === 1
    ? integration.audience[0]
    : t`Asset and Service Management`;

export const networkSummary = (integration, shown = 2) => {
  const sorted = [...(integration.service_network || [])].sort();
  return {
    text: sorted.length === 0 ? t`None` : sorted.slice(0, shown).join(', '),
    rest: sorted.slice(shown),
  };
};

export const triggerLabels = (integration) => {
  const labels = [];
  if ((integration.trigger_type || []).includes('http_api_request')) {
    labels.push({ id: 'http', text: 'http', detail: integration.action });
  }
  if ((integration.events || []).length > 0) {
    labels.push({
      id: 'application_event',
      text: 'application_event',
      detail: [...integration.events].sort().join('\n'),
    });
  }
  return labels;
};

export const circuitBreakerOpen = (integration) =>
  Boolean(
    integration.circuit_breaker_enabled &&
      integration.circuit_breaker_current_enabled,
  );

export const resilienceFlags = (integration) => {
  const flags = [];
  if (integration.cache_enabled) flags.push({ id: 'cache', text: t`Cache` });
  if (integration.automatic_retry_enabled)
    flags.push({ id: 'retry', text: t`Auto Retry` });
  if (integration.circuit_breaker_enabled && !circuitBreakerOpen(integration))
    flags.push({ id: 'circuit_breaker', text: t`Circuit Breaker` });
  return flags;
};
